import React, { useEffect, useRef, useState } from 'react';
import { IonIcon } from '@ionic/react';
import { pause, play } from 'ionicons/icons';
import {
	AudioPlayerContainer,
	AudioPulse,
	AudioTrigger,
	Player,
} from './styles';

type AudioProps = {
	src: string;
};
const AudioPlayer: React.FC<AudioProps> = ({ src }) => {
	const [isPlaying, setIsPlaying] = useState(false);
	const [duration, setDuration] = useState<number>(0);
	const [currentTime, setCurrentTime] = useState<any>('00 : 00');
	const audioPlayer = useRef<any>(null);
	const animationRef = useRef<any>(); // this references the animation

	useEffect(() => {
		const audioElement = audioPlayer.current;
		if (!audioElement) return;

		const updateDuration = () => {
			if (!audioElement.duration || Number.isNaN(audioElement.duration)) {
				return;
			}
			const seconds = Math.floor(audioElement.duration);
			setDuration(seconds);
		};

		audioElement.addEventListener('loadedmetadata', updateDuration);
		audioElement.addEventListener('durationchange', updateDuration);

		if (audioElement.readyState >= 1) {
			updateDuration();
		}

		return () => {
			audioElement.removeEventListener('loadedmetadata', updateDuration);
			audioElement.removeEventListener('durationchange', updateDuration);
		};
	}, []);

	const resetAudio = () => {
		console.log('ENDED!');
		audioPlayer.current.currentTime = 0;
		setIsPlaying(false);
	};

	const whilePlaying = () => {
		let time = calculateTime(audioPlayer.current.currentTime);
		setCurrentTime(time);
		animationRef.current = requestAnimationFrame(whilePlaying);
	};

	const calculateTime = (secs: any) => {
		const minutes = Math.floor(secs / 60);
		const returnedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
		const seconds = Math.floor(secs % 60);
		const reuturnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

		return `${returnedMinutes} : ${reuturnedSeconds}`;
	};

	const togglePlayPause = () => {
		const prevValue = isPlaying;
		setIsPlaying(!prevValue);
		if (!prevValue) {
			audioPlayer.current.play();
			animationRef.current = requestAnimationFrame(whilePlaying);
		} else {
			audioPlayer.current.pause();
			cancelAnimationFrame(animationRef.current);
		}
	};
	return (
		<AudioPlayerContainer>
			<Player>
				<AudioPulse
					$delay={0}
					className={isPlaying ? 'playing' : 'paused'}
				/>
				<AudioPulse
					$delay={0.75}
					className={isPlaying ? 'playing' : 'paused'}
				/>
				<AudioPulse
					$delay={1.5}
					className={isPlaying ? 'playing' : 'paused'}
				/>
				<AudioTrigger
					onClick={() => {
						togglePlayPause();
					}}>
					{isPlaying ? (
						<IonIcon icon={pause} />
					) : (
						<IonIcon icon={play} />
					)}
				</AudioTrigger>
			</Player>

			<div>
				<div>{currentTime}</div>
				<div>{calculateTime(duration)}</div>
			</div>

			<audio ref={audioPlayer} controls onEnded={resetAudio}>
				<source src={src} type="audio/mpeg"></source>
			</audio>
		</AudioPlayerContainer>
	);
};

export default AudioPlayer;
